/**
 * Filters
 * @type {Object.<string, {name: string, fn: (item: Item) => boolean}>}
 */
export const filters = {
  all: {
    name: "history_item_helper_filter_all",
    fn: (item) => true,
  },
  updateLast24hr: {
    name: "history_item_helper_filter_update_last_24_hours",
    fn: (item) => {
      const last24Hours = new Date();
      last24Hours.setDate(last24Hours.getDate() - 1);
      return new Date(item.updated_at) > last24Hours;
    },
  },
  updateLast7d: {
    name: "history_item_helper_filter_update_last_7_days",
    fn: (item) => {
      const last7Days = new Date();
      last7Days.setDate(last7Days.getDate() - 7);
      return new Date(item.updated_at) > last7Days;
    },
  },
  updateLast30d: {
    name: "history_item_helper_filter_update_last_30_days",
    fn: (item) => {
      const last30Days = new Date();
      last30Days.setDate(last30Days.getDate() - 30);
      return new Date(item.updated_at) > last30Days;
    },
  },
  createdLast24hr: {
    name: "history_item_helper_filter_created_last_24_hours",
    fn: (item) => {
      const last24Hours = new Date();
      last24Hours.setDate(last24Hours.getDate() - 1);
      return new Date(item.created_at) > last24Hours;
    },
  },
  createdLast7d: {
    name: "history_item_helper_filter_created_last_7_days",
    fn: (item) => {
      const last7Days = new Date();
      last7Days.setDate(last7Days.getDate() - 7);
      return new Date(item.created_at) > last7Days;
    },
  },
  createdLast30d: {
    name: "history_item_helper_filter_created_last_30_days",
    fn: (item) => {
      const last30Days = new Date();
      last30Days.setDate(last30Days.getDate() - 30);
      return new Date(item.created_at) > last30Days;
    },
  },
  pinned: {
    name: "history_item_helper_filter_pinned",
    fn: (item) => Boolean(item.pinned_at),
  },
  unpinned: {
    name: "history_item_helper_filter_unpinned",
    fn: (item) => !item.pinned_at,
  },
};

/**
 * Sorts
 * @type { Object.<string, {name: string, fn: (a: Item, b: Item) => number}>}
 * @property {string} createdAtAsc
 * @property {string} updatedAtAsc
 * @property {string} nameAsc
 * @property {string} createdAtDesc
 * @property {string} updatedAtDesc
 * @property {string} nameDesc
 */
export const sorts = {
  updatedAtAsc: {
    name: "history_item_helper_sort_updated_at_ascending",
    fn: (a, b) => new Date(a.updated_at) - new Date(b.updated_at),
  },
  createdAtAsc: {
    name: "history_item_helper_sort_created_at_ascending",
    fn: (a, b) => new Date(a.created_at) - new Date(b.created_at),
  },
  nameAsc: {
    name: "history_item_helper_sort_name_ascending",
    fn: (a, b) => a.content.localeCompare(b.content),
  },
  updatedAtDesc: {
    name: "history_item_helper_sort_updated_at_descending",
    fn: (a, b) => new Date(b.updated_at) - new Date(a.updated_at),
  },
  createdAtDesc: {
    name: "history_item_helper_sort_created_at_descending",
    fn: (a, b) => new Date(b.created_at) - new Date(a.created_at),
  },
  nameDesc: {
    name: "history_item_helper_sort_name_descending",
    fn: (a, b) => b.content.localeCompare(a.content),
  },
};

export const sortsByPinnedAt = (a, b) => {
  if (a.pinned_at && b.pinned_at) {
    return new Date(b.pinned_at) - new Date(a.pinned_at);
  }
  if (a.pinned_at) return -1;
  if (b.pinned_at) return 1;
  return 0;
};
